import client from '@stores/apollo'
import gql from 'graphql-tag'
import { AssignmentPlanFragment } from '@api/fragments'
import { IAssignmentPlan } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface UpdateAssignmentPlanInput {
  id: string
  alias: string
}

interface IPayload {
  updateAssignmentPlan: {
    assignmentPlan: IAssignmentPlan
  }
}
const mutateHandler = handleFetchResult<IPayload, IAssignmentPlan>({
  handler: (data) => data.updateAssignmentPlan.assignmentPlan,
  name: 'Assignment Plan',
})

export default function update(input: UpdateAssignmentPlanInput): Promise<IAssignmentPlan> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation UpdateAssignmentPlan($input: UpdateAssignmentPlanInput!) {
    updateAssignmentPlan(input: $input) {
      assignmentPlan {
        ...AssignmentPlanFragment
      }
    }
  }
  ${AssignmentPlanFragment}
`
